export default {"src":"/evde-internet/_next/static/media/phone.cbc65a6e.svg","height":120,"width":120};